import { MultiLanguageString } from "./multi-language-string";

export class EvidenceProvider {
    success: boolean;
    message: string;
    evidenceIdentifier: string;
	evidenceTypeClassification: string;
	evidenceTitle: MultiLanguageString[];
	jurisdictionLevel: string;
    jurisdictionAdminL2: string;
    jurisdictionAdminL3: string;
    jurisdictionContextId: string;
    dataServiceEvidenceTypeIdentifier: string;
    accessServiceIdentifier: string;
    publisherIdentifier: string;
    publisherName: string;
    isSelected = false;
    showJurisdictionSelect = false;
    isValidProvider:boolean;
    evidenceProviderClassifications: EvidenceProviderClassification[];
    jurisdictionPosition: number | undefined;
    showCodeListSelect: boolean | undefined;
    errorMessage: string | undefined;
}

export class EvidenceProviderClassification {
    identifier: string;
    description: MultiLanguageString[];
    valueExpresion: string;
    type: string;
    codeList: any[];
    selectedValue: any;
}